export const VNINVOICE_MANAGER_SET_ORDER_NUMBER_MIN = 'VNINVOICE_MANAGER_SET_ORDER_NUMBER_MIN' // Sets the minimum order number.
export const VNINVOICE_MANAGER_SET_ORDER_NUMBER_MAX = 'VNINVOICE_MANAGER_SET_ORDER_NUMBER_MAX' // Sets the maximum order number.
